import { Subject } from "rxjs";
import { TicketNotificationUpdate } from "./types";

export const ticketNotificationUpdates$ =
  new Subject<TicketNotificationUpdate>();
